import {
    ChangeDetectionStrategy,
    Component,
    Injectable,
    Input,
} from '@angular/core';
import {
    ILoginAttempt,
    ODataResponse,
} from '@models';
import {
    GRID_SERVICE,
    IGridSource,
    ODataGridComponent,
} from '@pages/generics/grid';
import {
    LoginAttemptsService,
    ODataQueryOptions,
} from '@services';

@Injectable()
export class LoginAttemptSource implements IGridSource<ODataQueryOptions, ODataResponse<ILoginAttempt>> {
    public userId!: number;

    public get mapper() {
        return this._loginAttempts.mapper;
    }

    constructor(
        private _loginAttempts: LoginAttemptsService,
    ) { }

    public get(qo: ODataQueryOptions) {
        return this._loginAttempts.getInstanceSet(this.userId, qo);
    }
}

@Component({
    selector: 'ui-login-attempts-grid',
    templateUrl: './login-attempts.grid.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        LoginAttemptsService,
        LoginAttemptSource, {
            provide: GRID_SERVICE,
            useClass: LoginAttemptSource,
        }],
})
export class UiLoginAttemptsGridComponent extends ODataGridComponent<ILoginAttempt, number> {
    @Input()
    public set userId(value: number) {
        const svc = (this._service as LoginAttemptSource);
        if (
            !svc ||
            isNaN(value) ||
            svc.userId === value
        ) { return; }

        svc.userId = value;
        this._refresh$.next();
    }
}
